import { render, staticRenderFns } from "./ReviewsCategoriesColorScaleTableColumn.vue?vue&type=template&id=1fa71ee2&scoped=true&"
import script from "./ReviewsCategoriesColorScaleTableColumn.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesColorScaleTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesColorScaleTableColumn.vue?vue&type=style&index=0&id=1fa71ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa71ee2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
